<template>
<div>
    <div class="app-title">
        <div>
            <h2>{{ $t("tlt.shiftHandOver") }}    {{$t(word)}}</h2>
            <ul class="app-breadcrumb breadcrumb">
                <li class="breadcrumb-item">
                    <router-link to="/"><i class="fa fa-home"></i></router-link>
                </li>
                <li class="breadcrumb-item">
                    <router-link to="/prd"><span>{{$t('tlt.prd')}}</span></router-link>
                </li>
                <li class="breadcrumb-item">
                    <router-link to="/prd/shiftHandOver"><span>{{$t('tlt.shiftHandOver')}}</span></router-link>
                </li>
            </ul>
        </div>
        <div class="col-lg-4">
            <div class="float-lg-right">
                <button class="btn btn-outline-primary" v-on:click="MMFNew('shiftHandOver')">
                    <i class="fa fa-fw fa-lg fa-plus"></i>
                    <span class="text">{{ $t("btn.basic.add") }}</span>
                </button>
            </div>
        </div>
    </div>
    <section class="app-content">
        <div id="accordionFilter" class="content">
            <div class="card">
                <div id="collapseOne" class="collapse show " aria-labelledby="headingOne" data-parent="#accordionFilter">
                    <div class="card-body">
                        <form class="row">                           
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-required"></span>{{$t('lbl.basic.plant')}}:</label>
                                <input class="form-control" type="text" v-model="plantFilter">
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label">
                                    {{ $t("lbl.basic.shift") }} :
                                </label>
                                <select class="form-control" v-model="shiftFilter">
                                    <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                    <option value="1">{{ $t("甲") }}</option>
                                    <option value="2">{{ $t("乙") }}</option>
                                    <option value="3">{{ $t("丙") }}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label">
                                    {{ $t("lbl.basic.startDay") }} :
                                </label>
                                <mmf-datepicker  v-model="startDayFilter"></mmf-datepicker>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label">
                                    {{ $t("lbl.basic.endDay") }} :
                                </label>
                                <mmf-datepicker  v-model="endDayFilter"></mmf-datepicker>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label">
                                    {{ $t("lbl.shiftHandOver.status") }} :
                                </label>
                                <select class="form-control" v-model="statusFilter">
                                    <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                    <option value="0">{{ $t("lbl.shiftHandOver.status.unHandover") }}</option>
                                    <option value="1">{{ $t("lbl.shiftHandOver.status.handovered") }}</option>
                                </select>
                            </div>


                            <div class="col-lg-2 align-self-end">
                                <div class="float-lg-right">
                                    <!-- 暂存按钮 -->
                                    <button class="btn btn-outline-secondary mr-1" type="button" v-on:click="MMFClearFilter('shiftHandOver')">
                                        <i class="fa fa-fw fa-lg fa-eraser"></i>
                                        <span class="text">{{ $t("btn.basic.clear") }}</span>
                                    </button>

                                    <button class="btn btn-outline-secondary mr-1" type="button" v-on:click="loadEdit()">
                                        <span class="text">{{ $t("lbl.shiftHandOver.temStorage") }}</span>
                                    </button>

                                    <button class="btn btn-primary" type="button" v-on:click="load()">
                                        <i class="fa fa-fw fa-lg fa-search"></i>
                                        <span class="text">{{ $t("btn.basic.search") }}</span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <!--显示列表-->
        <div id="shiftHandOverListTable" class="content">
            <div class="card my-1">

                <div
                        id="collapseTwo"
                        class="collapse show"
                        aria-labelledby="headingTwo"
                        data-parent="#accordionResult"
                >
                    <div class="card-body">
                        <div class="bs-component">
                        </div>
                        <mmf-table id="test" entity="shiftHandOver" inline-actions-disabled :singleChoice='true' :disableEdit="able">
                            <div slot="btnList" class="btn-group" slot-scope="slotProps">
                                <button
                                    :disabled="slotProps.checkedLength!=1 || able===false"
                                    v-bind:class="'btn btn-outline-primary btn-sm'" 
                                    v-b-modal.modal-handover>                                 
                                    <i class="fa fa-tasks" aria-hidden="true"></i>  
                                    <span class="text">{{$t('btn.prd.shifthandover.affirm')}}</span>                                         
                                </button>                                 
                            </div>
                        </mmf-table>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <b-modal id="modal-handover" title="确认" @ok="affirmShiftHandover(entity)">  
        <h3>请确认交接内容无误后，进行交接！</h3>
    </b-modal>
</div>
</template>

<script>
import {
    mapState,
    mapActions
} from "vuex";
import {
    createHelpers
} from 'vuex-map-fields';
import {
    gridFields,
    filterFields
} from "@/model/prd/shiftHandOver/ShiftHandOver";
import MmfTable from "@/components/MmfTable";
import MmfDatepicker from "@/components/MmfDatepicker";

// create a helper to generate getters and setters with namespace
const {
    mapFields
} = createHelpers({
    getterType: 'shiftHandOver/getField',
    mutationType: 'shiftHandOver/updateField',
});

export default {
    components: {MmfTable,MmfDatepicker},
    data() {
        return {
            able:false,
            word:""
        }
    },
    name: "ShiftHandOverList",
    computed: {
        // generate and add getters and setters using the filter names defined in
        // entity model
        ...mapFields(filterFields),
        //define the state of rows and fields of grid
        ...mapState({
            rows: state => state.shiftHandOver.rows,
            checkedItems: state => state.shiftHandOver.checkedItems,
            tableColumns: gridFields,
            entity: state => state.shiftHandOver.entity
        })
    },
    methods: {
        ...mapActions("base", ["MMFselectRow", "MMFselectAllRows", "MMFNew",
            "MMFEdit", "MMFLoadRows", "MMFDelete", "MMFClearFilter"
        ]),
        ...mapActions("shiftHandOver", ["affirmShiftHandover"]),
        loadEdit(){
            this.able = false;
            this.word="lbl.shiftHandOver.temStorage";
            this.editAbleFilter=1;
            this.MMFLoadRows('shiftHandOver');
        },
        load(){
            this.able = true;
            this.word = "lbl.shiftHandOver.saveStorage";
            this.editAbleFilter=-1;
            this.MMFLoadRows('shiftHandOver');
        }
    },
};
</script>
